import React from 'react';
import OriginalLanguageButton from '../../../../components/shared/OriginalLanguageButton';
import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';

const createReactClass = require('create-react-class');

const TextEditItem = createReactClass({
  getInitialState() {
    const isEditShown = this.props.canEdit && !this.props.data;
    return { isEditShown, submitInProgress: false };
  },
  componentWillUnmount() {
    if (this.subscribeReportChanges) this.subscribeReportChanges.unsubscribe();
  },
  componentWillReceiveProps(nextProps) {
    if (this.state.isEditShown && nextProps.data != this.props.data) this.hide();
  },
  submitError() {
    this.setState({ submitFailed: true, submitInProgress: false });
  },
  submitSuccess(data) {
    this.setState({ isEditShown: false, submitInProgress: false });
    this.props.handleSubmitSuccess(data);
  },
  submit() {
    this.saveEdit();
  },
  saveEdit() {
    this.props.handleSubmit(this.refs.itemTextArea.value);
    this.setState({ submitInProgress: true, submitFailed: false });
  },
  submitComplete() {},
  show() {
    if (this.props.canEdit) this.setState({ isEditShown: true });
  },
  hide() {
    this.setState({ isEditShown: false });
  },
  toggleShowInTranslatedLang() {
    this.setState({ showInTranslatedLang: !this.state.showInTranslatedLang });
  },
  render() {
    let itemText = '';
    let placeholderText = StringConstantsMixin.strings.TRACK_DETAIL.NO_DESCRIPTION_ADDED;
    if (this.props.placeholderText) {
      placeholderText = this.props.placeholderText;
    } else if (this.props.canEdit) {
      placeholderText = StringConstantsMixin.strings.TRACK_DETAIL.TELL_WHAT_YOU_DID;
    }
    let containerStyle = { width: '100%' };

    if (this.state.isEditShown) {
      // Edit mode
      let statusText = null;
      let textAreaDisabled = false;
      if (this.state.submitInProgress) {
        statusText = StringConstantsMixin.strings.SAVING;
        textAreaDisabled = true;
      } else if (this.state.submitFailed) {
        statusText = StringConstantsMixin.strings.TRACK_DETAIL.CANNOT_SAVE_UPDATE;
      }
      let cancelHandler = this.hide;
      let submitHandler = this.submit;
      if (this.state.submitInProgress) {
        cancelHandler = null;
        submitHandler = null;
      }
      const buttonContainer = (
        <div className="edit-buttons">
          <span className="btn btn-slim blue rounded write-review" onClick={submitHandler}>
            {StringConstantsMixin.strings.SAVE}
          </span>
          <span className="link" onClick={cancelHandler}>
            {StringConstantsMixin.strings.CANCEL}
          </span>
          <b>{statusText}</b>
        </div>
      );
      const textarea = (
        <textarea
          ref="itemTextArea"
          className="overview"
          style={{ width: '100%' }}
          disabled={textAreaDisabled}
          maxLength={this.props.maxlength}
          defaultValue={this.props.dataSource || this.props.data}
          placeholder={placeholderText}
          itemProp="description"
        />
      );
      containerStyle = { width: '100%', padding: '2.5px 5px' };
      itemText = (
        <ul className="comment-content rounded feed-user-content">
          <li>
            {textarea}
            {buttonContainer}
          </li>
        </ul>
      );
    } else {
      // Non-Edit Mode
      let innerText = placeholderText;
      if (!this.state.showInTranslatedLang && this.props.dataSource) {
        innerText = this.props.dataSource;
      } else if (this.props.data) {
        innerText = this.props.data;
      }

      const showOrigLanBtn = this.props.dataSource ? (
        <OriginalLanguageButton
          active={this.state.showInTranslatedLang}
          handleClick={this.toggleShowInTranslatedLang}
          eventSource="Map Description"
        />
      ) : null;

      if (this.props.canEdit) {
        // User has ability to edit
        const linkText = this.props.data ? StringConstantsMixin.strings.EDIT : StringConstantsMixin.strings.ADD;
        itemText = (
          <div className="edit-add-button">
            <p className={StringConstantsMixin.constants.XLATE.GOOGLE}>{innerText}</p>
            {showOrigLanBtn}
            <div className="link" onClick={this.show}>
              {linkText}
            </div>
          </div>
        );
      } else {
        // Default
        containerStyle = { width: '100%', padding: '15px 15px 10px 20px' };
        itemText = (
          <div>
            <p className={StringConstantsMixin.constants.XLATE.GOOGLE}>{innerText}</p>
            {showOrigLanBtn}
          </div>
        );
      }
    }
    return (
      <div style={containerStyle} className="tab-content overview comment">
        {itemText}
      </div>
    );
  }
});

const DescriptionSection = createReactClass({
  render() {
    let { placeholderText } = this.props;
    if ((!this.props.data || !this.props.data.length) && !this.props.canEdit) {
      placeholderText = '';
    }
    let heading = null;
    if (this.props.showHeader)
      heading = (
        <div className="action-bar">
          <menu className="title clearfix overview-menu tabs">
            <li className="active">
              <h3>
                <a name={StringConstantsMixin.strings.TAB_NAMES.DESCRIPTION}>{StringConstantsMixin.strings.TAB_NAMES.DESCRIPTION}</a>
              </h3>
            </li>
          </menu>
        </div>
      );
    return (
      <div id="description-section">
        {heading}
        <TextEditItem
          ref="textEditItem"
          data={this.props.data}
          dataSource={this.props.dataSource}
          canEdit={this.props.canEdit}
          placeholderText={placeholderText}
          handleSubmit={this.props.handleSubmit}
          handleSubmitSuccess={this.props.handleSubmitSuccess}
          messagingChannel={this.props.messagingChannel}
        />
      </div>
    );
  }
});

TextEditItem.defaultProps = {
  showHeader: true
};

export { DescriptionSection };
